import { country } from "@features/country/data";
import { BaseRepository } from "@features/shared/data";
import user from "user";
import { MerchantRepositoryContract, ShoppingSummary } from "../../domain";
import { userApiUrl } from "../constants";
import { mapMerchantFulfillmentRate } from "../mappers/merchant.mapper";
import { MerchantFulfillmentRateModel } from "../types";

export class MerchantRepository
  extends BaseRepository
  implements MerchantRepositoryContract
{
  public async getShoppingSummary(): Promise<ShoppingSummary> {
    const response = await this.http.get<ShoppingSummary>(
      userApiUrl.merchantShoppingSummary,
    );

    return response.data;
  }

  public async getMerchantFulfillmentRate() {
    const { data } = await this.http.get<MerchantFulfillmentRateModel>(
      userApiUrl.merchantFulfillmentRate(user.id, country.code),
    );

    return mapMerchantFulfillmentRate(data);
  }
}
